import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import {
    Col, Row, Form, FormGroup, Button
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ConfirmAccount } from '../../../redux/Action/Auth/SignupAction'
import Teacher from '../../../assets/Images/TeacherLogo.png'
import Assistant from '../../../assets/Images/AssistantLogo.png'
import Student from '../../../assets/Images/StudentLogo.png'
import Parent from '../../../assets/Images/ParentLogo.png'
import RenderField from '../../../components/Fields/fields'
import String from '../../../assets/Locales/teacher_locales.js';
import { Inputs } from './inputSettings'
import validate from './validation';
import LoadingBar from 'react-redux-loading-bar'
import '../Login/login.css'

class Login extends Component {
    onSubmit = (values) => {
        // console.log(values)
        let code = {
            email: JSON.parse(localStorage.getItem('sendEmail')).email,
            code: values.code,
            type: JSON.parse(localStorage.getItem('sendEmail')).type
        }
        // console.log("COODE", code, localStorage.getItem('sendEmail'), localStorage.getItem('sendEmail').type )
        this.props.ConfirmAccount(code, localStorage.getItem('Language'))
    }
    render() {
        if (this.props.verified) {
            return (
                <Redirect to="/home" />
            )
        }
        let lang = localStorage.getItem("Language");
        if (lang) {
            String.setLanguage(localStorage.getItem("Language"));
        } else {
            lang = "ar"
            String.setLanguage("ar");
        }
        const { handleSubmit, submitting } = this.props
        return (
            <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "black" }} />
                </div>
                <div className="login-content" style={{ direction: lang === 'ar' ? 'rtl' : 'ltr' }}>
                    <div className="login-container" style={{ height: window.innerHeight - 90 }}>
                        <Row className="login-image-content">
                            <Col md="12" className="big-img">
                                <img src={Teacher} alt="Teacher" />
                            </Col>
                            <Col md="12" className="small-imgs">
                                <img src={Student} alt="Student" />
                                <img src={Parent} alt="Parent" />
                                <img src={Assistant} alt="Assistant" />
                            </Col>
                        </Row>
                        <Row >
                            <Col md="6" lg="4" style={{ margin: 'auto', marginTop: '5%' }}>
                                <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    {
                                        Inputs.map((row, index) => {
                                            return (
                                                <FormGroup>
                                                    {
                                                        row.map((element, index) => {
                                                            return (
                                                                <Field
                                                                    lang={lang}
                                                                    type={element.type}
                                                                    name={element.name}
                                                                    component={RenderField}
                                                                    label={lang === "ar" ? element.label.ar : element.label.en}
                                                                    placeholder={element.placeholder}
                                                                    options={element.options}
                                                                    optionTitle={element.optionTitle ? (lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                                // title={lang === "ar" ? element.title.ar : element.title.en}
                                                                />
                                                            )
                                                        })

                                                    }
                                                </FormGroup>
                                            )
                                        })
                                    }
                                    <Col md="12" className="login-submit-Btn" style={{ marginTop: '10%' }} id="loginBtn">
                                        <Button type="submit" className="btn submitBtn" disabled={submitting}> {String.loginBtn}  </Button>
                                    </Col>
                                </Form>
                                
                            </Col>
                        </Row>
                    </div>
                </div >

            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
        verified: state.login.verified
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        ConfirmAccount
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(Login));